import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {Container, CssBaseline, Box, TextField, Alert} from '@mui/material';
import SectionSpinner from '../Loading/SectionSpinner/SectionSpinner';
import OutlinedButton from '../Button/OutlinedButton/OutlinedButton';

import Logo from '../../assets/images/rezzil-logo-full.png';

import './LoginForm.css';

function LoginForm(props){

    
    const navigate = useNavigate();

    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({"has_error":false, "msg":""});
    
    async function loginUser(credentials) {

        setError({"has_error":false, "msg":""});
        setLoading(true);
        
        return fetch(process.env.REACT_APP_API_ENDPOINT+'user/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(credentials)
        })
        .then(res => res.json())
        .then(function (data){
    
            if(data.code === 200){


                if(data.data.club.id === process.env.REACT_APP_REZZIL_CLUB_ID){
                    //Request was successful
                    localStorage.setItem('token', data.data.accessToken);
                    localStorage.setItem('userRole', data.data.role);
                    localStorage.setItem('userProfile', JSON.stringify(data.data.user));
                    localStorage.setItem('clubProfile', JSON.stringify(data.data.club));

                    return true;
                }
                else{
                    console.log("Not a Rezzil staff member.");
                    setError({"has_error":true, "msg":"Your account doesn't have access to this service."});
                    return false;
                }
    
            }
            else if(data.code === 400){
                console.log("Incorrect username and/or password.");
                setError({"has_error":true, "msg":"Incorrect username and/or password."});
                return false;
            }
            else{
                setError({"has_error":true, "msg":"An error occured during the login."});
                console.log("An error occured during the login.");
                return false;
            }        
        },
        err => {
            setError({"has_error":true, "msg":"An error occured during the login."});
            console.log("An error occured during the login.");
            return false;
        });
            

    }


    const handleSubmit = async event => {
        event.preventDefault();
        await loginUser({
            email,
            password
        }).then(function(loginSuccess){

            if(loginSuccess){
                props.handleLogin();
                navigate("/control");
                setLoading(false);
            }else{
                // Show error
                setLoading(false);
            }
        });



    }


    return(
        <>
            <div id="login-bg"></div>
            <Container component="main" maxWidth="xs">
            <CssBaseline />
                
            <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                
            }}
            >
                    <img src={Logo} alt='Rezzil Logo' id="login-logo"/>
                    <Box
                        component="form"
                        onSubmit={handleSubmit}
                        noValidate
                        id="login-container"
                        sx={{ 
                            mt: 1
                        }}
                    >

                        {
                            error.has_error &&
                            <Alert severity="error">{error.msg}</Alert>
                        }
                        


                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email Address"
                            name="email"
                            type="email"
                            autoComplete="email"
                            autoFocus
                            onChange={e => setEmail(e.target.value)}
                        />

                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            onChange={e => setPassword(e.target.value)}
                            sx={{ 
                                mb: 3
                            }}
                        />


                        {
                            loading &&
                            <SectionSpinner/>
                        }
                        {
                            !loading &&
                            <OutlinedButton
                                text={'Login to Squads Live'}
                                onClick={handleSubmit}
                                fullWidth
                            />
                        }
                    </Box>
                </Box>
            </Container>
        </>
    );

}

export default LoginForm;